import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'auth/unauthorized',
        loadComponent: () => import('@core/pages/unauthorized/unauthorized.page').then(c => c.UnauthorizedPage)
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'workstreams'
    },
    {
        path: 'workstreams',
        loadChildren: () => import('@features/workstreams/workstreams.routes').then(({ routes }) => routes)
    },
    {
        path: 'sequences',
        loadChildren: () => import('@features/sequences/sequences.routes').then(({ routes }) => routes)
    },
    {
        path: 'toolbox',
        loadChildren: () => import('@features/toolbox/toolbox.routes').then(({ routes }) => routes)
    },
    {
        path: 'faq',
        loadChildren: () => import('@features/faq/faq.routes').then(({ routes }) => routes)
    },
    {
        path: 'admin',
        loadChildren: () => import('@features/admin/admin.routes').then(({ routes }) => routes)
    },
    {
        path: 'not-found',
        loadComponent: () => import('@core/pages/not-found/not-found.page').then(c => c.NotFoundPage)
    },
    // Activity owns the top-level `/my-activities` and `/activity-feed` URLs, so it mounts on the empty path.
    {
        path: '',
        loadChildren: () => import('@features/activity/activity.routes').then(({ routes }) => routes)
    },
    {
        path: '**',
        redirectTo: 'not-found',
        pathMatch: 'full'
    }
];
